package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Place
import fyi.moko.hotpl.domain.repository.PlaceRepository
import kotlinx.coroutines.flow.Flow

/** Streams all saved places in the default home order. */
class ObservePlacesUseCase(
    private val repository: PlaceRepository,
) {
    operator fun invoke(): Flow<List<Place>> = repository.observePlaces()
}
